import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <p>Copyright &copy; 2021 , MadaPas</p>
    </footer>
  );
};

export default Footer;
